import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssetComponent } from './asset.component';
import { AssetEditComponent } from './edit/asset-edit.component';

const routes: Routes = [
  { path: '',  component: AssetComponent },
  { path: ":id", component: AssetEditComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetRoutingModule { }
